<template>
    <b-form-group :label="label" :description="description" :invalid-feedback="validationError">
        <b-form-select v-model="content" @input="updateContent()" :options="options" :multiple="multiple" :state="state"></b-form-select>
    </b-form-group>
</template>

<script>
export default {
  name: "SelectControl",
  props: {
    label: {},
    description: {},
    options: {},
    multiple: {
      default: false
    },
    value: {
      required: true
    },
    required: {
      default: false
    },
    requiredError: {
      default: 'This field is required'
    },
    customValidation: {}
  },
  data() {
    return {
      content: this.value,
      originalValue: this.value,
      state: null,
      validationError: null,
      hasEverValidated: false
    };
  },
  computed: {
    isValid: function () {
      if (!this.hasEverValidated)
        this.validateContent(this.content, this.content);

      return this.state === null || this.state === true;
    }
  },
  methods: {
    updateContent() {
      this.$emit('input', this.content);
    },
    validateContent: function (newValue, oldValue) {
      this.hasEverValidated = true;

      let validationError = null;

      if (this.required !== null && this.required !== false && !newValue)
        validationError = this.requiredError;
      else if (typeof(this.customValidation) === 'function') {
        let retVal = this.customValidation(newValue, oldValue);
        if (retVal !== true && retVal !== null)
          validationError = retVal;
        else {
          this.state = retVal;
          validationError = null;
        }
      }

      this.validationError = validationError;
      if (this.validationError != null)
        this.state = false;
      else {
        if (this.originalValue == newValue)
          this.state = null;
        else
          this.state = true;
      }
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      if (this.content == oldValue) {
        // The value in the underlying model changed, and it wasn't triggered by anything in this control
        this.hasEverValidated = false;
        this.state = null;
        this.content = newValue;
        this.originalValue = newValue;
      }
    },
    content: function (newValue, oldValue) {
      this.validateContent(newValue, oldValue);
    }
  },
  mounted () {
  }
};
</script>